import React from 'react'

// component
import AlertPopup from '../../../../Popup/AlertPopup'

const alertPopupExtendStyles = `
    margin: 33px auto 0 auto;
    left: 50%;
    transform: translate(-50%, 0);
`

const ErrorLogin400Code2 = ({ closePopup }) => {
    return (
        <AlertPopup
            type="ERROR"
            handleClickBtn={closePopup}
            extendStyles={alertPopupExtendStyles}
        >
            Email không đúng!
        </AlertPopup>
    )
}

export default ErrorLogin400Code2
